export default __webpack_public_path__ + "static/media/bgBarGraph.00104215.svg";